<template>
  <div v-if="post" style="font-family: Dosis, Helvetica, Arial, sans-serif; font-size: 12px; width: 100%; max-width: 1000px; margin: 0 auto; padding: 10px; box-sizing: border-box;">
    <!-- Ligne 1 : Photo principale + Titre/Description -->
    <div style="display: flex; gap: 8px; margin-bottom: 10px; height: 330px;">
      <!-- Photo principale -->
      <div style="flex: 0 0 466px;">
        <img v-if="post.photoPrincipale != null" :src="post.photoPrincipale.url" style="width: 100%; height: 100%; object-fit: cover;"/>
      </div>

      <!-- Titre + Description -->
      <div style="flex: 1; box-sizing: border-box; overflow: hidden; display: flex; flex-direction: column; gap: 8px;">
        <div style="border: solid; border-color: #00b4cc; border-width: 1px; padding: 8px; text-align: center; overflow: hidden; height: 50px; display: flex; align-items: center; justify-content: center;">
          <h2 style="margin: 0; font-size: 26px; font-weight: bold;">{{ titreVitrine }}</h2>
        </div>
        <div style="flex: 1; border: solid; border-color: #00b4cc; border-width: 1px; padding: 15px; box-sizing: border-box; overflow: hidden;">
          <p style="font-size: 13px; text-align: justify; line-height: 1.5; margin: 0;">
            {{ truncateText(post.texte) }}
          </p>
        </div>
      </div>
    </div>

    <!-- Ligne 2 : Photo 1, Photo 2, Photo 3, Prix -->
    <div style="display: flex; gap: 8px; margin-bottom: 10px; height: 150px;">
      <!-- Photo 1 -->
      <div style="flex: 0 0 150px;">
        <img v-if="post.photos && post.photos[1]" :src="post.photos[1].url" style="width: 100%; height: 100%; object-fit: cover;"/>
      </div>

      <!-- Photo 2 -->
      <div style="flex: 0 0 150px;">
        <img v-if="post.photos && post.photos[2]" :src="post.photos[2].url" style="width: 100%; height: 100%; object-fit: cover;"/>
      </div>

      <!-- Photo 3 -->
      <div style="flex: 0 0 150px;">
        <img v-if="post.photos && post.photos[3]" :src="post.photos[3].url" style="width: 100%; height: 100%; object-fit: cover;"/>
      </div>

      <!-- Prix -->
      <div style="flex: 1; border: solid; border-color: #00b4cc; border-width: 1px; padding: 10px; box-sizing: border-box; display: flex; align-items: center; justify-content: center; text-align: center;">
        <div>
          <div v-if="post.typeObjet === 5200">
            <span style="font-size: 14px; display: block; margin-bottom: 5px; font-weight: bold;">{{ $t('posts.view.saleConditionsPriceCmiHouseLand') }}</span>
            <strong style="font-size: 32px; display: block; color: #00b4cc;">{{ post.prixDisplay || '250 000 €' }}</strong>
          </div>
          <div v-else-if="post.typeObjet >= 1200 && post.typeObjet < 1300">
            <span style="font-size: 14px; display: block; margin-bottom: 5px; font-weight: bold;">{{ $t('posts.view.saleConditionsPrice') }}</span>
            <strong style="font-size: 32px; display: block; color: #00b4cc;">{{ post.prixDisplay || '250 000 €' }}</strong>
          </div>
          <div v-else>
            <span style="font-size: 14px; display: block; margin-bottom: 5px; font-weight: bold;">{{ $t('posts.view.saleConditionsPriceCmiLand') }}</span>
            <strong style="font-size: 32px; display: block; color: #00b4cc;">{{ post.prixDisplay || '250 000 €' }}</strong>
          </div>
          <div v-if="post.prix_terrain" style="font-size: 10px; margin-top: 8px;">
            {{ $labels.prix_terrain }}<br>{{ post.prix_terrain }} {{ post.devise_iso_4217 }}
          </div>
        </div>
      </div>
    </div>

    <!-- Ligne 3 : Données, DPE/GES, Contact -->
    <div style="display: flex; gap: 8px; height: 180px;">
      <!-- Données -->
      <div style="flex: 0 0 280px; border: solid; border-color: #00b4cc; border-width: 1px; padding: 10px 15px; box-sizing: border-box; font-size: 12px; overflow: hidden; background-color: white;">
        <div v-if="post.surface_habitable" style="margin-bottom: 6px;">
          <strong>{{ $labels.surface_habitable }}</strong> : {{ post.surface_habitable }} m²
        </div>
        <div v-if="post.nb_pieces_logement" style="margin-bottom: 6px;">
          <strong>{{ $labels.nb_pieces_logement }}</strong> : {{ post.nb_pieces_logement }}
        </div>
        <div v-if="post.nombre_de_chambres" style="margin-bottom: 6px;">
          <strong>{{ $labels.nombre_de_chambres }}</strong> : {{ post.nombre_de_chambres }}
        </div>
        <div v-if="post.nb_salles_de_bain" style="margin-bottom: 6px;">
          <strong>{{ $labels.nb_salles_de_bain }}</strong> : {{ post.nb_salles_de_bain }}
        </div>
        <div v-if="post.nb_garages">
          <strong>{{ $labels.nb_garages }}</strong> : {{ post.nb_garages }}
        </div>
      </div>

      <!-- DPE / GES -->
      <div style="flex: 0 0 320px; border: solid; border-color: #00b4cc; border-width: 1px; box-sizing: border-box; position: relative; overflow: hidden; background-color: white;">
        <div v-if="post.dpe_etiquette_conso && post.dpe_etiquette_ges" style="position: absolute;  top: 47%; left: 70%; transform: translate(-50%, -50%) scale(0.78);">
          <EtiquetteDPEGESPdfNew :post="post"></EtiquetteDPEGESPdfNew>
        </div>
      </div>

      <!-- Contact -->
      <div style="flex: 1; border: solid; border-color: #00b4cc; border-width: 1px; padding: 15px; box-sizing: border-box; background-color: #f5f5f5; display: flex; flex-direction: column; justify-content: center;">
        <div style="text-align: center; margin-bottom: 12px;">
          <img v-if="sitimmoUser.logoUrl"
               :src="'data:image/png;base64,' + sitimmoUser.logo" 
               style="max-width: 100px; max-height: 50px;"/>
        </div>
        <div style="font-size: 12px; line-height: 1.6; text-align: center;">
          <strong style="font-size: 13px;">{{ sitimmoUser.raisonSociale || 'Prestige immobilier' }}</strong><br>
          <span v-if="post.adresse_contact_a_afficher">
            {{ post.adresse_contact_a_afficher }}<br>
            {{ post.code_postal_contact_a_afficher }} {{ post.ville_contact_a_afficher }}<br>
          </span>
          <span v-else>
            {{ sitimmoUser.adresse || 'La Vallée' }}<br>
            {{ sitimmoUser.codePostal || '35830' }} {{ sitimmoUser.ville || 'Betton' }}<br>
          </span>
          <span v-if="post.telephone_a_afficher">Tél. : {{ post.telephone_a_afficher }}</span>
          <span v-else>Tél. : {{ sitimmoUser.telephone || '02 88 99 77 55' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EtiquetteDPEGESPdfNew from '@/pages/posts/forms/Block/EtiquetteDPEGESPdfNew'
import { getTitreAlternatif } from '@/helpers/posts/getTitreAlternatif'

export default {
  name: 'PostPdfImmoCmiLandscape',
  components: { EtiquetteDPEGESPdfNew },
  props: ['post', 'sitimmoUser', 'universe'],
  data () {
    return {
      prixDisplay: null,
      environnementData: [],
      environnementString: ''
    }
  },
  computed: {
    titreVitrine () {
      return getTitreAlternatif(this.post)
    }
  },
  methods: {
    truncateText (texte) {
      if (!texte) return ''
      let suffix = ''
      if (texte.length > 600) {
        suffix = '...'
      }
      return texte.substring(0, 600) + suffix
    },
    displayBoolean (value) {
      if (value === true) {
        return this.$t('general.yes')
      }
      if (value === false) {
        return this.$t('general.no')
      }
      return value
    },
    formatEnvironnement () {
      if (!this.post) return

      if (this.post.belle_vue) {
        this.environnementData.push(this.$labels.belle_vue)
      }
      if (this.post.vue_sur_mer) {
        this.environnementData.push(this.$labels.vue_sur_mer)
      }
      if (this.post.est_calme) {
        this.environnementData.push(this.$labels.est_calme)
      }
      if (this.post.avec_vis_a_vis) {
        this.environnementData.push(this.$labels.avec_vis_a_vis)
      }
      if (this.post.proche_bus) {
        this.environnementData.push(this.$labels.proche_bus)
      }
      if (this.post.proche_tram) {
        this.environnementData.push(this.$labels.proche_tram)
      }
      if (this.post.proche_metro) {
        this.environnementData.push(this.$labels.proche_metro)
      }
      if (this.post.proche_gare) {
        this.environnementData.push(this.$labels.proche_gare)
      }
      if (this.post.proche_commerces) {
        this.environnementData.push(this.$labels.proche_commerces)
      }
      if (this.post.ecoles_a_proximitees) {
        this.environnementData.push(this.$labels.ecoles_a_proximitees)
      }
      if (this.post.proche_creche) {
        this.environnementData.push(this.$labels.proche_creche)
      }
      if (this.post.espaces_verts) {
        this.environnementData.push(this.$labels.espaces_verts)
      }

      if (this.environnementData.length > 0) {
        this.environnementString = this.environnementData.join(', ')
        this.environnementString = this.environnementString.toLowerCase()
        this.environnementString = this.environnementString[0].toUpperCase() + this.environnementString.slice(1)
      }
    }
  },
  beforeMount () {
    this.formatEnvironnement()
  }
}
</script>

<style scoped>
</style>
